import { setNameRowStay } from "../setNameRowStay"

export const getStayRequiredFields = (index: number) => [
  `${setNameRowStay(index)}.locationPhoneNumber1`,
  `${setNameRowStay(index)}.emailAddress1`,
]
